var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelPhotoSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 11,
  viewBox: "0 0 12 11",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M9.991 0C11.101 0 12 .9 12 1.992v7.016c0 1.1-.902 1.992-2.009 1.992H2.01C.899 11 0 10.1 0 9.008V1.992C0 .892.902 0 2.009 0zm.014 1h-8.01C1.455 1 1 1.447 1 1.998v7.004c0 .552.446.998.995.998h8.01c.54 0 .995-.447.995-.998V1.998A.996.996 0 0 0 10.005 1M4 4.5l4 3L7 6l1-1 2 2.096V9H2V7.096zM8 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
})));
export default SvgChannelPhotoSm;